import { useUserData } from '~/hooks-data/use-user-data'
import {
  makeFullNameFromClerkUser,
  makeShortNameFromClerkUser,
} from '@basehub/data/auth/utils/make-full-name-from-clerk-user'
import { getSystemAuthor } from '~/lib/system-authors'

export const useUsernameFromId = (
  userId: string,
  options?: Partial<{ short: boolean }>
) => {
  const systemAuthor = getSystemAuthor(userId)
  const { data: userData } = useUserData(systemAuthor ? undefined : userId)

  let username
  switch (true) {
    case !userData:
      username = systemAuthor?.name || ''
      break
    case options?.short:
      username = makeShortNameFromClerkUser(userData)
      break
    default:
      username = makeFullNameFromClerkUser(userData)
      break
  }

  return { username, systemAuthor }
}
